export default __webpack_public_path__ + "EULA.html";